import { int32, uint16, uint32, uint8 } from '../../utils';

const genParamBin = (item: any) => {
  const { source_id, arithmetic_op, flags, value } = item;
  const bin = Buffer.concat([
    uint8(arithmetic_op),
    uint8(flags),
    uint16(source_id),
    int32(value)
  ]);
  return bin;
};

const genCompareBin = (item: any) => {
  const { logical_op, type, count, params } = item;
  const paramBins = params.map((param: any) => genParamBin(param));
  const reserved = 0;
  const bin = Buffer.concat([
    uint8(logical_op),
    uint8(type),
    uint16(count),
    uint32(reserved),
    Buffer.concat(paramBins)
  ]);
  return bin;
};

export const genConditionBin = (item: any) => {
  /**
   * typedef struct _condition_record_data {
   *    uint8_t logical_op;
   *    uint16_t data_count;
   *    uint16_t compare_count;
   *    uint16_t data_src[0];
   *    compare_param_t compares[0];
   * }  __attribute__((packed)) condition_record_data_t;
   */
  const { logical_op, data_count, compare_count, data_src, compares } = item;
  const compareBins = compares.map((compare: any) => genCompareBin(compare));
  const reserved = 0;
  const reserved1 = 0;
  const binBufferData = [
    uint8(logical_op),
    uint8(reserved),
    uint16(data_count),
    uint16(compare_count),
    uint16(reserved1),
    // 如果是事件，则没有data_src, 即不需要将data_src添加到bin当中去, 如果数组为空自然不会编写进去，所以可以不用单独判断
    Buffer.concat(data_src.map((item: any) => uint16(item))),
    Buffer.concat(compareBins)
  ];
  const bin = Buffer.concat(binBufferData);
  return bin;
};
